import React from "react";
import { CheckIcon } from "./icons";

export default function Packages(props) {
  const { packages, activePackage, setActivePage } = props;
  return (
    <div className="grid grid-cols-2 gap-2">
      {packages.map((pkg, i) => (
        <div
          key={i}
          onClick={() => setActivePage(pkg.name)}
          className="hover:shadow-2xl cursor-pointer w-auto p-2 bg-white text-center rounded-3xl shadow-xl"
        >
          <h1 className="text-theme font-semibold text-2xl">{pkg.name}</h1>
          <p className="pt-2 tracking-wide">
            <span className="text-gray-400 align-top">KES </span>
            <span className="text-3xl font-semibold">{pkg.price}</span>
            <span className="text-gray-400 font-medium">/ year</span>
          </p>
          <hr className="mt-4 border-1" />
          <div className="pt-4">
            {pkg.points.map((point) => (
              <p
                key={point}
                className="flex items-center text-sm mb-2 text-gray-400 text-left"
              >
                <CheckIcon />
                <span className="pl-2">{point}</span>
              </p>
            ))}
            {activePackage === pkg.name ? (
              <button onClick={() => setActivePage(pkg.name)}>
                <p className="flex w-full py-2 px-4 bg-green-500 mt-8 rounded-xl text-white">
                  <span className="font-medium">Selected</span>
                  <CheckIcon iconClasses="text-white h-5 w-5" />
                </p>
              </button>
            ) : (
              <button onClick={() => setActivePage(pkg.name)}>
                <p className="w-full py-2 px-4 bg-tertiaryTheme mt-8 rounded-xl text-gray-600">
                  <span className="font-medium">Choose Plan</span>
                </p>
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
